<template>

  <section class="content">

    <collecte-modal title="Supprimer une collecte"
                    v-on:close="doCloseAnyModals"
                    v-if="deleteModal === true">
      <collecte-delete slot="body"
                       v-on:close="doCloseAnyModals"
                       :collecte="collecte"></collecte-delete>
    </collecte-modal>

    <collecte-modal title="Modifier un contenant"
                    v-on:close="doCloseAnyModals"
                    v-if="updateModal === true">
      <collecte-form slot="body"
                     v-on:close="doCloseAnyModals"
                     :update-collecte="collecte"></collecte-form>
    </collecte-modal>

    <collecte-modal title="Créer un nouveau contenant"
                    v-on:close="doCloseAnyModals"
                    v-if="createModal === true">
      <collecte-form slot="body"
                     v-on:close="doCloseAnyModals"></collecte-form>
    </collecte-modal>

    <collecte-modal title="Importer des Contenants en masse"
                    v-on:close="doCloseAnyModals"
                    v-if="createCsvModal === true"
    >
      <collecte-form-csv slot="body"
                         v-on:close="doCloseAnyModals"></collecte-form-csv>
    </collecte-modal>

    <section class="content-toolbar content-toolbar-contenant">
      <div class="btn btn-primary"
           v-on:click="clickCreate()" v-if="currentUser.role !== 'COLLECTIVITY_USER'">Créer un nouveau contenant
      </div>
      <div class="btn import-btn btn-primary"
           v-on:click="clickCreateFromCsv()" v-if="currentUser.role !== 'COLLECTIVITY_USER'">Importer des contenants en masse
      </div>
      <div class="btn  export-btn btn-primary"
           v-on:click="exportDemandes()">Exporter tous les contenants
      </div>
      <div class="btn  export-btn btn-primary"
           v-on:click="downloadTemplateFile()">Télécharger le fichier template
      </div>
    </section>
    <section class="filter">
      <div class="form-group-collecte col-sm-2">
        <label>Numéros de contenant</label>
        <treeselect class="tree-select" v-if="contenants.availablesNumeros"
                    :multiple="true"
                    v-model="contenants.filters.idNumeros"
                    :searchable="true"
                    :options="contenants.availablesNumeros"
                    sortValueBy="LEVEL"
                    :default-expand-level="1"
                    :limit="1"
                    :max-height="300"
                    placeholder="Sélectionner un numéro"
                    :allways-opened="false"
                    :disable-branch-nodes="true"
                    v-on:change="reloadCollectes()"
                    @input="reloadCollectes">
        </treeselect>
      </div>
      <div class="form-group-collecte col-sm-2">
        <label>Secteur</label>
        <treeselect class="tree-select" v-if="contenants.availableSecteurs"
                    :multiple="true"
                    v-model="contenants.filters.idSecteurs"
                    :searchable="true"
                    :options="contenants.availableSecteurs"
                    sortValueBy="LEVEL"
                    :default-expand-level="1"
                    :limit="1"
                    :max-height="300"
                    placeholder="Sélectionner un secteur"
                    :allways-opened="false"
                    :disable-branch-nodes="true"
                    v-on:change="reloadCollectes()"
                    @input="reloadCollectes">
        </treeselect>
      </div>
      <div class="form-group-collecte col-sm-2">
        <label>Type</label>
        <select v-model="selectedType" class="form-control collecte-filters" id="type" v-on:change="reloadCollectes()">
          <option value="0">Sélectionner un type</option>
          <option value='CORBEILLE'>Corbeille</option>
          <option value='CANIBOX'>Canibox</option>
        </select>
      </div>
      <div class="form-group-collecte col-sm-2">
        <label>Adresse</label>
        <treeselect class="tree-select" v-if="contenants.availablesAdresses"
                    :multiple="true"
                    v-model="contenants.filters.idAdresses"
                    :searchable="true"
                    :options="contenants.availablesAdresses"
                    sortValueBy="LEVEL"
                    :default-expand-level="1"
                    :limit="1"
                    :max-height="300"
                    placeholder="Sélectionner une adresse"
                    :allways-opened="false"
                    :disable-branch-nodes="true"
                    v-on:change="reloadCollectes()"
                    @input="reloadCollectes">
        </treeselect>
      </div>
    </section>
    <br>
    <collectes-list v-on:delete="clickDelete"
                    v-on:edit="clickEdit">
    </collectes-list>

  </section>

</template>

<script>
import {mapState} from 'vuex'
import CollectesList from './CollectesList'
import CollecteDelete from './CollecteDelete'
import CollecteForm from './CollecteForm'
import CollecteModal from '../commons/CollecteModal'
import CollecteFormCsv from './CollecteFormCsv'
import Treeselect from '@riophae/vue-treeselect'
import * as _ from 'lodash'

export default {
  computed: {
    ...mapState([
      'maitrise',
      'secteurs',
      'collectes',
      'contenants',
      'currentUser'
    ]),
  },
  components: {
    CollectesList,
    CollecteDelete,
    CollecteForm,
    CollecteModal,
    CollecteFormCsv,
    Treeselect,
  },
  data: function () {
    return {
      deleteModal: false,
      updateModal: false,
      createModal: false,
      createCsvModal: false,
      collecte: null,
      types: [],
      selectedType: '0',
    }
  },
  methods: {
    preparedTypesObject: function () {
      this.types.push('Corbeille')
      this.types.push('Canibox')
    },
    reloadCollectes: function () {
      let $this = this
      if (this.selectedType === 'CORBEILLE') {
        this.contenants.filtredContenants = _.filter(this.contenants.data, function (collecte) {
          return collecte.typeContenant === 'CORBEILLE'
        })
        //  console.log('After filter', $this.collectes.filtredCollectes)
      } else if (this.selectedType === 'CANIBOX') {
        this.contenants.filtredContenants = _.filter(this.contenants.data, function (collecte) {
          return collecte.typeContenant === 'CANIBOX'
        })
      } else {
        console.log('Im in the else')
        this.contenants.filtredContenants = this.contenants.data
      }
      // Drop down list Secteur
      if (this.contenants.filters.idSecteurs.length > 0) {
        console.log('we are in secteurs contenant => ', this.contenants.filters.idSecteurs)
        this.contenants.filtredContenants = _.filter(this.contenants.filtredContenants, function (contenant) {
          return _.find($this.contenants.filters.idSecteurs, function (sec) {
            return contenant.secteur_id === sec
          })
        })
        console.log($this.contenants.filtredContenants)
      }
      // Drop down list numéro de contenant
      if (this.contenants.filters.idNumeros.length > 0) {
        console.log('we are in numéro contenant => ', this.contenants.filters.idNumeros)
        this.contenants.filtredContenants = _.filter(this.contenants.filtredContenants, function (contenant) {
          return _.find($this.contenants.filters.idNumeros, function (num) {
            console.log("contenant => " , contenant)
            console.log("num => " , num)
            return contenant.id === num
          })
        })
        console.log($this.contenants.filtredContenants)
      }
      // Drop down list adresse de contenant
      if (this.contenants.filters.idAdresses.length > 0) {
        console.log('we are in adresse contenant')
        this.contenants.filtredContenants = _.filter(this.contenants.filtredContenants, function (collecte) {
          return _.find($this.contenants.filters.idAdresses, function (ad) {
            return collecte.adresse === ad
          })
        })
        console.log($this.contenants.filtredContenants)
      }

      this.$store.dispatch('updateContenantsFilter')
    },
    clickDelete: function (collecte) {
        this.collecte = collecte
        this.deleteModal = true
    },
    clickEdit: function (collecte) {
        this.collecte = collecte
        this.updateModal = true
    },
    clickCreate: function () {
      this.createModal = true
    },
    clickCreateFromCsv: function () {
      this.createCsvModal = true
    },
    doCloseAnyModals: function () {
      this.deleteModal = false
      this.updateModal = false
      this.createModal = false
      this.createCsvModal = false
    },
    exportDemandes: function () {
      this.$store.dispatch('generateCollectesReporting');
    },
    downloadTemplateFile: function () {
      this.$store.dispatch('downloadTemplateFile')
    },
  },
  mounted: function () {
    //  this.$store.dispatch('fetchContenantsOfVille', {arg: 'contenants'})
   // this.$store.dispatch('feedFiltersOfContenants')
    /*     this.$store.dispatch('fetchCollectes')
        this.$store.dispatch('fetchSecteurs', this.$store.state.currentMaitriseArrondissement)
        this.$store.dispatch('fetchCantonniers', this.$store.state.currentMaitriseArrondissement)
        this.preparedTypesObject() */
  },
}
</script>

<style lang="scss">
@import '../../../scss/variables';

.export-btn {
  background-image: url('/static/img/icon-dl.svg');
  background-repeat: no-repeat;
  background-position: 15px center;
  padding: 7px 15px 8px 45px;

}

.import-btn {
  background-image: url('/static/img/upload.svg');
  background-repeat: no-repeat;
  background-position: 15px center;
  padding: 7px 15px 8px 45px;

}

.content-toolbar-contenant {
  // margin-top: 2rem;
}

.filter {
  height: 65px
  // margin-bottom: 5%;
  // margin-left: 10%;
}

.form-group-collecte {
  width: 24%;
}

.collecte-filters {
  border-radius: 6px;
  background-color: #aadc14;
  color: #030f40;
  border: none;
  font: 14px/22px 'DinMedium';
  height: 36px;
}

/* @media (min-width: 1300px){
  .filter{
    margin-bottom: 3%;
  }
} */
</style>



// WEBPACK FOOTER //
// Collecte.vue?329f3a00